import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { moduleAction } from "../../utils/functions";
import { MOD_CUSTOM, WRITE } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import NoClient from "../../../../static/images/group-418.svg";
import i18next from 'i18next';
export class BlankClient extends Component {
  render() {
    const { roles } = this.props;
    return <div id="no-client">
      <img src={NoClient} className="no-client-img" />
      <h3 className="no-client-h3">{i18next.t('providers.new.alert.title')}</h3>
      <p className="no-register">
      {i18next.t('providers.new.alert.message')}</p>
      <p className="no-register-option">
      {i18next.t('providers.new.alert.action')}</p>
      <div className="no-client-line"></div>
      <div className="form-actions clearfix">
        {moduleAction(roles, MOD_CUSTOM, WRITE) && (
          <Link to="/bscadministrator/clients/add" className="add-button flex-element">
            <button id="saveProvider" className="button button--pill btnAgregar">
            {i18next.t('providers.new.alert.button')}
            </button>
          </Link>
        )}
      </div>
    </div>
  }
}
export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(BlankClient);
